export enum RegisterMode {
  SIGNUP_FORM = 'SIGNUP_FORM',
  VERIFY_CODE = 'VERIFY_CODE',
}
